// extracted by mini-css-extract-plugin
export default {"container":"teams-container_container__K9iUn","spacer":"teams-container_spacer__XtZ7F"};